import React, { Fragment } from 'react';
 
import PageTitle from '../../components/pagetitle'
import Scrollbar from '../../components/scrollbar'
import { useParams } from 'react-router-dom'
import Services from '../../api/service'
import RelatedService from './related';
import Discuss from './discuss';
import ServiceSidebar from './sidebar';
import Logo from '../../images/logo.svg'
import Footer from '../../components/footer';
import ContactForm from '../../components/ContactFrom'
import Navbar2 from '../../components/Navbar2'
const ServiceSinglePage = (props) => {
    const { id } = useParams()
    
    const serviceDetails = Services.find(item => item.Id === id)
    
    return (
        <Fragment>
            <Navbar2 Logo={Logo} hclass={'wpo-header-style-3'}/>
            <PageTitle pageTitle={serviceDetails.sTitle} pagesub={'Services'} />
            <div className="wpo-service-single-area section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-12">
                            <div className="wpo-service-single-wrap">
                                <div className="wpo-service-single-item">
                                    <div className="wpo-service-single-main-img">
                                        <img src={serviceDetails.sImg} alt=""/>
                                    </div>
                                    <div className="wpo-service-single-title">
                                        <h3>{serviceDetails.sTitle}</h3>
                                    </div>
                                    <p>{serviceDetails.description}</p>
                                    { /* <p>Hac nibh fermentum nisi, platea condimentum cursus velit dui. Massa volutpat odio
                                        facilisis purus sit elementum. Non, sed velit dictum quam. Id risus pharetra est, at
                                        rhoncus, nec ullamcorper tincidunt. Id aliquet duis sollicitudin diam, elit sit.</p> */ }
                                    {/* <div className="row mt-4">
                                        <div className="col-md-6 col-sm-6 col-12">
                                            <div className="wpo-p-details-img">
                                                <img src="assets/images/service-single/1.png" alt=""/>
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-12">
                                            <div className="wpo-p-details-img">
                                                <img src="assets/images/service-single/1.png" alt=""/>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                                <div className="wpo-service-single-item list-widget">
                                    <div className="wpo-service-single-title">
                                        <h3>{serviceDetails.section1.title}</h3>
                                    </div>
                                    <p>{serviceDetails.section1.description}</p>
                                    <ul>
                                    {serviceDetails.section1.details.map((element,index)=> <li key={index}>{element}</li>)}
                                        
                                    </ul>
                                </div>
                                <div className="wpo-service-single-item">
                                    <div className="wpo-service-single-title">
                                        <h3> {serviceDetails.section2.title} </h3>
                                    </div>
                                    <p> {serviceDetails.section2.description} </p>
                                </div>
                                <div className="wpo-service-single-item list-widget">
                                    <div className="wpo-service-single-title">
                                        <h3> {serviceDetails.section3.title}</h3>
                                    </div>
                                    <ul>
                                    {serviceDetails.section3.details.map((element,index)=> <li key={index}>{element}</li>)}
                                     
                                    </ul>
                                </div>
                               {/* <RelatedService/> */} 
                               <div className="col col-lg-10 offset-lg-1 wpo-contact-pg-section">
                               <div className="wpo-contact-form-area">
                                <ContactForm/>
                                </div>
                                </div>
                                <section className="wpo-contact-map-section">
                <div className="wpo-contact-map">
                    <iframe 
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3397.5869670421757!2d-7.993720825106074!3d31.617775574169507!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xdafef000f8a327b%3A0xb6017a5a2ca36d59!2sGet%20Riad!5e0!3m2!1sfr!2sma!4v1739494726417!5m2!1sfr!2sma"  
                        title="Localisation de Get Riad"
                        width="400" 
                        height="150" 
                        style={{ border: "0" }}  
                        allowFullScreen  
                        loading="lazy"  
                        referrerPolicy="no-referrer-when-downgrade">
                    </iframe>
            </div>
            </section>
                                 {/* <Discuss/> */}
                            </div>
                        </div>
                        <ServiceSidebar/>
                    </div>
                </div>
            </div>
            <Footer ftClass={'wpo-site-footer-s2'}/>
            <Scrollbar />
        </Fragment>
    )
};
export default ServiceSinglePage;
